export var NEW_PAYMENT_INSTRUMENT = -1;
export var ORIGINAL_PAYMENT = -2;
export var REFUND_BY_CHECK = -3;